// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header___JJGX","mobileLogoLink":"Header_mobileLogoLink__BiPN1"};